import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Titulo from '../comum/Titulo'
import { buscarFilaVendasUrbanas } from '../../util/offlineStorage'

class PainelListarVendasUrbanasOffline extends React.Component {
  constructor (props) {
    super(props)
    this.state = { vendas: [], carregando: true }
  }

  componentDidMount () {
    this.carregarVendas()
    this.interval = setInterval(() => this.carregarVendas(), 10000)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  async carregarVendas () {
    try {
      const fila = await buscarFilaVendasUrbanas() || []
      const idEmpresa = this.props.empresaSelecionada && this.props.empresaSelecionada.id
      // um mesmo dispositivo pode acumular vendas offline de mais de uma empresa
      // (troca de atuação) — mostra só as da empresa selecionada no momento
      const daEmpresa = idEmpresa
        ? fila.filter(v => v.dadosVenda && v.dadosVenda.empresaId === idEmpresa)
        : fila
      this.setState({ vendas: daEmpresa, carregando: false })
    } catch (e) {
      this.setState({ vendas: [], carregando: false })
    }
  }

  renderStatus (venda) {
    if (venda.erroSync) {
      return (
        <span className="vx-gp-badge vx-gp-badge--cancelado" title={venda.erroSync}>
          Erro: {venda.erroSync}
        </span>
      )
    }
    if (venda.statusServidor === 'PROCESSANDO') {
      return <span className="vx-gp-badge vx-gp-badge--processando">Em processamento...</span>
    }
    return <span className="vx-gp-badge vx-gp-badge--pendente">Pendente</span>
  }

  renderVenda (venda) {
    const dv = venda.dadosVenda || {}
    const descRota = venda.cidadeOrigemNome && venda.cidadeDestinoNome
      ? `${venda.cidadeOrigemNome} → ${venda.cidadeDestinoNome}`
      : '-'
    const ref = (venda.idChaveOffline || '').substring(0, 8)

    return (
      <div key={venda.idChaveOffline} className="vx-vo-row">
        <div className="vx-vo-cell" data-label="Ref.">
          <span className="vx-vo-ref">{ref}...</span>
        </div>
        <div className="vx-vo-cell" data-label="Empresa">
          {venda.empresaNome || '-'}
        </div>
        <div className="vx-vo-cell" data-label="Itinerário">
          {venda.itinerarioLabel || '-'}
        </div>
        <div className="vx-vo-cell" data-label="Trecho">
          {descRota}
        </div>
        <div className="vx-vo-cell" data-label="Passageiro">
          {venda.nomePassageiro || dv.nomePassageiro || '-'}
        </div>
        <div className="vx-vo-cell" data-label="Valor">
          {Number(venda.valorTotal || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </div>
        <div className="vx-vo-cell" data-label="Status">
          {this.renderStatus(venda)}
        </div>
      </div>
    )
  }

  render () {
    const { vendas, carregando } = this.state

    return (
      <div className="row internas">
        <Titulo texto="Vendas Urbanas Offline" urlRetorno="/painel-vendas-urbanas" />
        <div className="col-12">
          <p className="text-muted" style={{ marginTop: -12, marginBottom: 16 }}>
            Vendas urbanas realizadas sem conexão neste dispositivo, aguardando sincronização automática.
          </p>
          {carregando ? (
            <div className="text-center p-4">Carregando...</div>
          ) : vendas.length === 0 ? (
            <div className="alert alert-info text-center">
              Nenhuma venda urbana offline pendente neste dispositivo.
            </div>
          ) : (
            <div className="vx-vo-table">
              <div className="vx-vo-header">
                <div className="vx-vo-cell">Ref.</div>
                <div className="vx-vo-cell">Empresa</div>
                <div className="vx-vo-cell">Itinerário</div>
                <div className="vx-vo-cell">Trecho</div>
                <div className="vx-vo-cell">Passageiro</div>
                <div className="vx-vo-cell">Valor</div>
                <div className="vx-vo-cell">Status</div>
              </div>
              {vendas.map(v => this.renderVenda(v))}
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada
})

export default withRouter(connect(mapStateToProps)(PainelListarVendasUrbanasOffline))
